import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    left: '0',
    top: '0',
    width: "100%",
    height: "100%",
    display: "table",
    background: "rgba(0, 0, 0, 0.5)",
    zIndex: '999999999',
    position: 'fixed'
  }
}));

function AppGlobalLoader(props) {
  const classes = useStyles();

  const {
    isLoading
  } = props;

  return (isLoading ?
    <div className={classes.root}>
      <LinearProgress />
    </div> : null
  );
}

AppGlobalLoader.defaultProps = {
  isLoading: false
}

const mapStateToProps = state => ({
  isLoading: state.APP_DATA.isLoading
});


export default connect(mapStateToProps)(AppGlobalLoader);
